import { SelectOption } from '@fleet-beat/core';

export enum GeofenceCategory {
  RiskZone = 'risk-zone',
  RestrictedZone = 'restricted-zone',
  FuelStation = 'fuel-station',
  TerminalYard = 'terminal',
  TruckStopRestArea = 'rest-area',
  Uncategorised = 'uncategorised',
}

export enum GeofenceShape {
  Circle = 'circle',
  Polygon = 'polygon',
  Rectangle = 'rectangle',
  State = 'state',
}

export const GeofenceCategories: SelectOption[] = [
  {
    value: GeofenceCategory.RiskZone,
    label: 'Risk Zone',
  },
  {
    value: GeofenceCategory.RestrictedZone,
    label: 'Restricted Zone',
  },
  {
    value: GeofenceCategory.FuelStation,
    label: 'Fuel Station',
  },
  {
    value: GeofenceCategory.TerminalYard,
    label: 'Terminal / Yard',
  },
  {
    value: GeofenceCategory.TruckStopRestArea,
    label: 'Truck Stop / Rest Area',
  },
  {
    value: GeofenceCategory.Uncategorised,
    label: 'Uncategorised',
  },
];
